import { Pipe, PipeTransform } from '@angular/core';

import { IPlacedDevice } from '../models/grid.model';
import { ProductRangesConstants } from '../models/product-ranges.constants';

@Pipe({
    name: 'isPatchPanel',
    standalone: false
})
export class IsPatchPanelPipe implements PipeTransform {

  transform(selectedDevice: IPlacedDevice): boolean {
    return [ProductRangesConstants.PATCHPANEL_16_PORT_RANGE_ID, ProductRangesConstants.PATCHPANEL_8_PORT_RANGE_ID]
      .indexOf(selectedDevice?.device.productRangeId) > -1;
  }

}
